import React, { useMemo } from "react";

import { IFeatureFlag } from "../../generated/types";

export interface IFeatureFlagsContext {
    isFeatureFlagEnabled(featureFlag: IFeatureFlag): boolean;
}

const DEFAULT: IFeatureFlagsContext = {
    isFeatureFlagEnabled: () => false,
};

export const FeatureFlagsContext = React.createContext<IFeatureFlagsContext>(DEFAULT);

interface IProps {
    activeFeatureFlags: IFeatureFlag[] | undefined;
}

export const FeatureFlagsContextProvider: React.FC<React.PropsWithChildren<IProps>> = ({
    activeFeatureFlags,
    children,
}) => {
    const activeFeatureFlagSet = useMemo((): Set<IFeatureFlag> => new Set(activeFeatureFlags), [activeFeatureFlags]);

    const contextValue = useMemo(
        (): IFeatureFlagsContext => ({
            isFeatureFlagEnabled: (featureFlag) => activeFeatureFlagSet.has(featureFlag),
        }),
        [activeFeatureFlagSet],
    );

    return <FeatureFlagsContext.Provider value={contextValue}>{children}</FeatureFlagsContext.Provider>;
};
